export enum CategoryCardAction {
	IN_CART,
	ENROLLED,
	AVAILABLE
}
